import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import {  Inject, NgZone, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { ErrorDialogComponent } from 'src/app/components/utility/error-dialog/error-dialog.component';
import { cacheKeys } from 'src/app/constants/cache-keys';
import { states } from 'src/app/constants/states';
import { searchIconSVG } from 'src/app/constants/svgs/search-icon';
import { iterateAPIConfig } from 'src/app/helpers/api-resp-helper';
import { generateSlug } from 'src/app/helpers/slug-helper';
import { createDeptUrl } from 'src/app/helpers/url-helper';
import { PageAPIResp } from 'src/app/models/api-config.model';
import { APIConfigService } from 'src/app/services/api-config.service';
import { CallAPIService } from 'src/app/services/call-api.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { StoreService } from 'src/app/services/store.service';
import { environment } from 'src/environments/environment';
import { LanguageHandlerService } from 'src/app/services/language-handler.service';
import { UtilsService } from 'src/app/services/utils.service';
@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent implements OnInit {
  
  public isSearchKeySubs!:Subscription;
  dataIsNotLoaded:boolean = false;
  searchKey: any; 
  selectedTab:string = 'all';
  servicesList: any;
  departmentsCount: any = 0;
  servicesCount: any = 0;
  schemesCount: any = 0;
  totalCount: any = 0;
  departmentList: any;
  schemeList: any;
  digiLockerList: any;
  digiLockerCount: any;
  constructor(
    public shareDataService: ShareDataService,
    public apiService: CallAPIService,
    public router: Router,
    private matDialog: MatDialog,
    public langHandlerService: LanguageHandlerService,
    private utilService: UtilsService
  ) {
  }

  ngOnInit(): void {
    this.isSearchKeySubs = this.shareDataService.isSearchKey.subscribe((response)=>{
      this.dataIsNotLoaded = false;
      const currentSearch = localStorage.getItem('searchedText');
      if(!response && currentSearch) {
        response = JSON.parse(currentSearch);
      }
      if(response){
        this.selectedTab = response?.type;
        this.searchKey = response?.key;
        const language = JSON.parse(localStorage.getItem('langDate')!);
        this.apiService.callSearchAPI('search', {keyword: response?.key, language: language?.lang, mode: 'web'}).subscribe((result:any) => {
          this.dataIsNotLoaded = true;
          const res = result;
          this.departmentList = res?.departments;
          this.schemeList = res?.schemes;
          this.servicesList = res?.services;
          this.digiLockerList = res?.documents;
          this.departmentsCount = res?.departmentsCount || 0;
          this.servicesCount = res?.servicesCount || 0;
          this.schemesCount = res?.schemesCount || 0;
          this.digiLockerCount = res?.documentsCount || 0;
          this.selectedTab = 'all';
          this.selectTab(this.selectedTab);
          this.totalCount = this.servicesCount + this.departmentsCount + this.schemesCount;
        },
        (err) => {
          this.dataIsNotLoaded = true;
        })
      }
      else{
        this.dataIsNotLoaded = true;
      }
    });
   
  }
  
  selectTab(tab:string){
    const divElement:any = document.getElementById('scrollId');
    divElement.scrollTop = 0;

    this.selectedTab = tab;
  }
  
  navigateBack(){
    this.router.navigateByUrl('/');
  }
  navigateToSchemeDetail(data:any){
    const slug = data.slug;
    const schemeName = this.langHandlerService.currentLang === 'en' ? generateSlug(data?.scheme_name, slug): `${slug}.html`;
    this.router.navigate([`scheme/detail/${schemeName}`]); 
  }
  
  navigateToDeptInfo(item: any, type:string) {
    if (type === 'department') {
      this.router.navigateByUrl(`/department/${generateSlug(item.disname)}`);
    } else {
      this.redirectToService(item);
    }
  }
  
  redirectToService(item: any, customMsg?: string) {
    const services:any = this.servicesList.map((item:any) => {
      return {
        name: item.service_name,
        url: item.url,
        deptImageUrl: item.image_url,
        deptName: item.department_name,
        desc: item.description,
        rating: item.score,
        id: item.service_id,
        type: item.service_type,
        platformList: 'all',
        deptId: item.department_id
      }
    })

    const service:any = {
      name: item.service_name,
        url: item.url,
        deptImageUrl: item.image_url,
        deptName: item.department_name,
        desc: item.description,
        rating: item.score,
        deptId: item.department_id,
        type: item.service_type
    }
    
    const isLoadService = this.utilService.checkSrvAccess(
      item.service_id,
      service,
      services
    );

    if (!isLoadService) {
      return;
    }

    const webNewUrl = `${environment.deployUrl}/web_new/department`;
    const isUrlV2 = item.url.includes('UmangVersion2');
    const isUrlDeptt = item.url.includes('deptt');

    if (isUrlV2) {
      const urlParams = encodeURIComponent(
        `${createDeptUrl(item.url)}&dept_id=${item.department_id}&dept_name=${
          item.department_name
        }`
      );
      window.open(`${webNewUrl}?url=${urlParams}`, '_self');
      return;
    } else if (isUrlDeptt) {
      const encodedUrlParam = encodeURIComponent(`${createDeptUrl(item.url)}`);
      window.open(
        `${webNewUrl}?url=${encodedUrlParam}&dept_id=${item.department_id}&dept_name=${item.department_name}`,
        '_self'
      );
      return;
    }

    const urlParams =
      encodeURIComponent(`${item.url.split('gov.in/')[1]}`) +
      `&dept_id=${item.department_id}&dept_name=${item.department_name}`;
      window.open(`${webNewUrl}?url=${urlParams}`, '_self');
    }
  goToDept(name: string, name2: string){}

  navigateToDigilocker(){
    window.open('https://web.umang.gov.in/web_new/home/digilocker/dashboard', '_self');
  }
}
